export const apiMall = "https://shop.hanlianglobalxmn.com/";
export const javaApi = "https://mp.hanlianglobalxmn.com:19922/";
export const appName = "汉连跨境分销go购够";
export const isOverseas = false;
export const unit = "元";
export const miniProgramUrl = "https://mp.hanlianglobalxmn.com:19922/scan";

export const footCopyrightInfo = "隐私政策 服务协议 Copyright © 2022 版权所有 保留一切权利";
export const footRecordInformation = "闽ICP备2021011669号-1";
export const appId = 'wx81eb7d194217415b';
export const isH5 = false; //是否H5
export const h5Url = ''
export const scanToOrderMsg = '微信扫一扫打开小程序下单'